import { Controller } from "react-hook-form";

import { CCard, CCardBody } from "@coreui/react";

import {
  C1Upload,
  CDate,
  CInput,
  CNumberInput,
  CTextarea,
} from "src/common/components/controls";

export const Info = ({ control }) => {
  return (
    <CCard>
      <CCardBody>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          <Controller
            control={control}
            name="code"
            render={({ field }) => (
              <CInput {...field} label="Mã Combo" required readOnly />
            )}
          />
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <CInput
                {...field}
                label="Tên Combo"
                placeholder="Nhập tên combo"
                required
              />
            )}
          />
          <Controller
            control={control}
            name="note"
            render={({ field }) => (
              <CTextarea
                {...field}
                label="Ghi chú"
                placeholder="Nhập ghi chú"
                className="row-span-3"
                minHeight={150}
              />
            )}
          />
          <Controller
            control={control}
            name="unit"
            render={({ field }) => (
              <CInput
                {...field}
                label="Đơn vị tính"
                placeholder="Nhập đơn vị tính"
                required
              />
            )}
          />
          <Controller
            control={control}
            name="vat"
            render={({ field }) => (
              <CNumberInput
                {...field}
                label="VAT (chỉ nhập số)"
                placeholder="Nhập VAT"
                required
                currency=" %"
              />
            )}
          />
          <Controller
            control={control}
            name="product_file"
            render={({ field }) => (
              <C1Upload {...field} label="Hình ảnh combo" required />
            )}
          />
          <Controller
            control={control}
            name="portion_file"
            render={({ field }) => (
              <C1Upload {...field} label="Hình ảnh định mức" required />
            )}
          />
          <Controller
            control={control}
            name="from"
            render={({ field }) => (
              <CDate {...field} label="Áp dụng từ ngày" required />
            )}
          />
          <Controller
            control={control}
            name="to"
            render={({ field }) => (
              <CDate {...field} label="Đến ngày" required />
            )}
          />
        </div>
      </CCardBody>
    </CCard>
  );
};
